export default __webpack_public_path__ + "static/media/meta.c384e4ff.png";